import { type } from '../env'

let socket
let apppId
let safariId

switch (type) {
  case 'local':
    socket = 'http://localhost:8080'
    apppId = '3a1d4289-f9cd-400d-bc79-8febf0721702'
    safariId = 'web.onesignal.auto.0d123f70-12e5-49b1-a758-f1abcc853120'
    break
  case 'dev':
    socket = 'https://adidas-testing.herokuapp.com'
    apppId = '4b359506-4986-4a40-bc68-3fa54e76c390'
    safariId = 'web.onesignal.auto.4bf12d4e-2e1c-4e2f-be7e-e4e315c9ca64'
    break
  case 'live':
    socket = 'https://adidas-server.herokuapp.com'
    apppId = '3b6fdffb-f135-4ba7-aa58-d6256c0028d2'
    safariId = 'web.onesignal.auto.271ef36b-44de-4fef-87dc-9a2f81b1418e'
    break
  default: break
}

export const socketUrl = socket
export const appId = apppId
export const safariWebId = safariId
export const apiUrl = `${socketUrl}/api`
export const facebookAppId = '119607855508796'
export const linkedInAppId = '86pm1xg1uygcy0'

// export const socketUrl = 'http://localhost:8080' // local
// export const socketUrl = 'https://adidas-testing.herokuapp.com' // dev
// export const socketUrl = 'https://adidas-server.herokuapp.com' // live
// Local
// export const appId = "3a1d4289-f9cd-400d-bc79-8febf0721702";
// export const safari_web_id = "web.onesignal.auto.0d123f70-12e5-49b1-a758-f1abcc853120";
// Dev
// export const appId = '4b359506-4986-4a40-bc68-3fa54e76c390'
// export const safari_web_id = 'web.onesignal.auto.4bf12d4e-2e1c-4e2f-be7e-e4e315c9ca64'
// Live
// export const appId = '3b6fdffb-f135-4ba7-aa58-d6256c0028d2'
// export const safari_web_id = 'web.onesignal.auto.271ef36b-44de-4fef-87dc-9a2f81b1418e'



// WEBPACK FOOTER //
// ./src/config/settings.js